import Vue from "vue";
import VueRouter from "vue-router";
import {AuthAccess, GuestAccess} from "@/access-rules";
import Home from "../views/Home.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      access: new AuthAccess(),
      title: "\u4F01\u4E1A\u8BA4\u8BC1",
      menuactive: 1
    },
    component: Home
  },
  {
    path: "*",
    name: "*",
    meta: {
      title: "\u4F01\u4E1A\u8BA4\u8BC1"
    },
    redirect: (to) => {
      return {path: "/", query: null};
    }
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  var _a, _b;
  let _access = new GuestAccess();
  if ((_a = to.meta) == null ? void 0 : _a.access) {
    _access = to.meta.access;
  }
  if ((_b = to.meta) == null ? void 0 : _b.title) {
    document.title = to.meta.title;
  }
  _access.next(to, from, next);
});
export default router;
